import { Application } from "@hotwired/stimulus"
import { registerControllers } from "stimulus-vite-helpers"
import ScrollTo from 'stimulus-scroll-to'

const application = Application.start()
application.register('scroll-to', ScrollTo)
const controllers = import.meta.globEager('./**/*_controller.js')
registerControllers(application, controllers)